import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api";

const SiteContext = createContext(null);

const DEFAULTS = {
  address: "D/1, S.S. Bhatt Chawl, Jawahar Nagar, J.P. Road, Khar East, Mumbai – 400051, Maharashtra, India. Opposite Railway Colony, above Deepak Jewellers.",
  phone: "+91 98333 88201",
  whatsapp: "919833388201",
  email: "prasadttutorgroup@gmail.com",
  hours: "Mon–Sat • Please contact us for exact batch timings",
  instagram_url: "https://instagram.com/prasadtutorgroup",
  youtube_url: "https://youtube.com/@prasadtutorials",
  maps_embed: "https://www.google.com/maps?q=Prasad+Tutor+Group,+D/1,+S.S.+Bhatt+Chawl,+Jawahar+Nagar,+J.P.+Road,+Khar+East,+Mumbai,+Maharashtra+400051&output=embed",
  maps_link: "https://maps.app.goo.gl/EDa5VpNEKFceadiVA",
  founder_photo: "",
  about_story: "",
  about_founder: "",
};

export const SiteProvider = ({ children }) => {
  const [site, setSite] = useState(DEFAULTS);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/site");
      if (data && Object.keys(data).length) setSite({ ...DEFAULTS, ...data });
    } catch { /* keep defaults */ }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return <SiteContext.Provider value={{ site, refresh }}>{children}</SiteContext.Provider>;
};

export const useSite = () => useContext(SiteContext);
